<script setup lang="js">
import { onMounted, ref } from 'vue';
import axios from "@/lib/axios";
import Swal from "sweetalert2";

const questions = ref([]);
const options = ref([]);
const answers = ref({});

const full_name = ref("");

const isLoading = ref(false);
const isSubmitting = ref(false);

const fetchData = async () => {
  isLoading.value = true;

  try {
    const [resQuestions, resOptions] = await Promise.all([
      axios.get('/api/pertanyaan-master'),
      axios.get('/api/pertanyaan-opsi'),
    ])

    questions.value = resQuestions.data.data;
    options.value = resOptions.data.data;
  } catch (error) {
    console.error('Gagal memuat data: ', error);
  } finally {
    isLoading.value = false;
  }
}

const getOptionByQuestions = (idQuestion) => {
  return options.value.filter(option => option.id_pertanyaan_detail === idQuestion);
}

const handleSubmit = async () => {
  isSubmitting.value = true;

  try {
    const payload = {
      nama: full_name.value,
      // TODO: Riwayat pengukuran masih hard-coded
      id_riwayat_pengukuran: 1,
      answers: Object.entries(answers.value).map(([questionId, option]) => ({
        id_pertanyaan_master: parseInt(questionId),
        id_pertanyaan_opsi: option.id,
        skor: option.skor
      }))
    };

    await axios.post('/api/jawaban-kuisioner', payload);

    Swal.fire({
      icon: "success",
      title: "Berhasil",
      text: "Jawaban berhasil dikirim!",
    });

    full_name.value = '';
    answers.value = {};
  } catch (error) {
    console.log("Gagal mengirim data: ", error);
    Swal.fire({
      icon: "error",
      title: "Gagal",
      text: "Gagal mengirim jawaban",
    });
  } finally {
    isSubmitting.value = false;
  }
}

onMounted(fetchData);
</script>

<template>
  <BContainer fluid>
    <BRow class="text-center">
      <h2 class="fw-bold fs-6">Kuisioner</h2>
      <p class="fs-16">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aliquid ipsa culpa totam.</p>
    </BRow>

    <!-- Skeleton Loader -->
    <BRow v-if="isLoading">
      <BCard>
        <div class="vstack gap-4">
          <div v-for="n in 3" :key="n" class="placeholder-glow">
            <span class="placeholder col-6 mb-3"></span>
            <div v-for="m in 4" :key="m" class="d-flex align-items-center mb-2">
              <div class="placeholder col-1 me-2" style="height:1rem; width:1rem; border-radius:50%;"></div>
              <span class="placeholder col-5"></span>
            </div>
          </div>
        </div>
      </BCard>
    </BRow>

    <BRow v-else>
      <BCard>
        <form @submit.prevent="handleSubmit" class="vstack gap-4">
          <div>
            <label for="full_name" class="form-label">Nama Lengkap</label>
            <input type="text" v-model="full_name" class="form-control" id="full_name" placeholder="Nama Lengkap Anda" required />
          </div>

          <!-- Daftar Pertanyaan Kuisioner -->
          <div
            v-for="question in questions"
            :key="question.id"
            class="shadow-none"
          >
            <p>{{ question.pertanyaan }}</p>
            <div
              v-for="option in getOptionByQuestions(question.id)"
              :key="option.id"
              class="form-check form-radio-primary"
            >
              <input 
                type="radio"
                v-model="answers[question.id]"
                :name="`question_${question.id}`"
                :id="`option_${option.id}`"
                :value="option"
                class="form-check-input"
                required
              />
              <label :for="`option_${option.id}`" class="form-check-label" >{{ option.opsi_jawaban }}</label>
            </div>
          </div>

          <!-- Submit Button -->
          <div class="text-end mb-4">
            <button
              :disabled="isSubmitting" 
              type="submit" 
              class="btn btn-primary"
            >
              {{ isSubmitting ? 'Mengirim...' : 'Kirim' }}
            </button>
          </div>
        </form>
      </BCard>
    </BRow>
  </BContainer>
</template>